import React, { createContext, useReducer, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';

const ProjectContext = createContext({});

const initialState = {
  startDate: null,
  duration: null,
  usersOfProjects: [],
  projectId: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_PROJECT_DETAIL': {
      return {
        ...state,
        startDate: action.payload.startDate,
        duration: action.payload.duration,
      };
    }
    case 'SET_USERS_PROJECTS_DETAIL': {
      return {
        ...state,
        usersOfProjects: action.payload.usersOfProjects,
      };
    }
    case 'SET_PROJECT_ID': {
      return {
        ...state,
        projectId: action.payload.projectId,
      };
    }
    default:
      return state;
  }
};

export const ProjectDetailProvider = ({ children }) => {
  const [{ startDate, duration, usersOfProjects, projectId }, dispatch] = useReducer(
    reducer,
    initialState,
  );

  useEffect(() => {
    dispatch({ type: 'SET_USERS_PROJECTS_DETAIL', payload: { usersOfProjects: [] } });
  }, [projectId]);

  const values = useMemo(() => ({
    startDate,
    duration,
    usersOfProjects,
    projectId,
    dispatch,
  }));
  return <ProjectContext.Provider value={values}>{children}</ProjectContext.Provider>;
};

ProjectDetailProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
export default ProjectContext;
